import { useContext } from 'react';
import { AppContext } from 'contexts/global/AppContext';

export const useAppContext = () => {
	return useContext(AppContext);
};
